import React from 'react';
import { Route, Routes } from 'react-router-dom';
import InviteResponse from '../pages/InviteResponse';
import Error404Page from '../pages/404';
import Welcome from '../pages/Welcome';
import Declined from '../pages/Declined';
import Accepted from '../pages/Accepted';
import Error from '../pages/Error';
import IndexPage from '../pages/Index';
import Closed from '../pages/Closed';
import Optin from '../pages/Optin';
import MarketingOptin from '../pages/MarketingOptin';
import MarketingOptout from '../pages/MarketingOptout';

export default function Router() {
  return (
    <Routes>
      <Route path="/:path" element={<Welcome />} />
      <Route path="/:path/response" element={<InviteResponse />} />
      <Route path="/:path/response/:inviteCode" element={<InviteResponse />} />
      <Route path="/:path/response/:inviteCode/optin/:optinCode" element={<Optin />} />
      <Route path="/:path/response/:inviteCode/marketingOptin/:optinCode" element={<MarketingOptin />} />
      <Route path="/:path/response/:inviteCode/accepted" element={<Accepted />} />
      <Route path="/:path/response/:inviteCode/marketingOptOut/:optoutCode" element={<MarketingOptout />} />
      <Route path="/:path/response/:inviteCode/marketingOptOut" element={<MarketingOptout />} />
      <Route path="/:path/response/:inviteCode/declined" element={<Declined />} />
      <Route path="/:path/response/:inviteCode/closed" element={<Closed />} />
      <Route path="/:path/response/:inviteCode/error" element={<Error />} />
      <Route path="/:path/:inviteCode" element={<Welcome />} />
      <Route path="/" element={<IndexPage />} />
      <Route path="*" element={<Error404Page />} />
    </Routes>
  );
}
